import { LOCALES } from '../constants';

const chat = {
  [LOCALES.PT]: {
    'chat.title': 'Chat',
    'chat.titleWithUnread': 'Chat, {count, plural, one {# mensagem não lida} other {# mensagens não lidas}}',
    'chat.unreadAnnouncement': '{count, plural, one {# mensagem não lida no Chat} other {# mensagens não lidas no Chat}}',
    'chat.expandNavigation': 'Expandir navegação',
    'chat.collapseNavigation': 'Recolher navegação',
    'chat.expandConversationList': 'Exibir lista de conversas',
    'chat.collapseConversationList': 'Ocultar lista de conversas',
    'chat.conversationList': 'Lista de conversas',
    'chat.messageLog': 'Mensagens',
    'chat.loading': 'Preparando o Chat...',
    'chat.unavailableTitle': 'Chat indisponível',
    'chat.unavailableDescription': 'Não foi possível carregar o Chat agora. Tente novamente.',
    'chat.retry': 'Tentar novamente',
    'chat.open': 'Abrir Chat',
    'chat.close': 'Fechar',
    'chat.messages': 'Mensagens do Chat',
    'chat.openWithUnread': 'Abrir Chat, {count} mensagens não lidas'
  },
  [LOCALES.EN]: {
    'chat.title': 'Chat',
    'chat.titleWithUnread': 'Chat, {count, plural, one {# unread message} other {# unread messages}}',
    'chat.unreadAnnouncement': '{count, plural, one {# unread Chat message} other {# unread Chat messages}}',
    'chat.expandNavigation': 'Expand navigation',
    'chat.collapseNavigation': 'Collapse navigation',
    'chat.expandConversationList': 'Show conversation list',
    'chat.collapseConversationList': 'Hide conversation list',
    'chat.conversationList': 'Conversation list',
    'chat.messageLog': 'Messages',
    'chat.loading': 'Preparing Chat...',
    'chat.unavailableTitle': 'Chat unavailable',
    'chat.unavailableDescription': 'We could not load Chat right now. Please try again.',
    'chat.retry': 'Try again',
    'chat.open': 'Open Chat',
    'chat.close': 'Close',
    'chat.messages': 'Chat messages',
    'chat.openWithUnread': 'Open Chat, {count} unread messages'
  },
  [LOCALES.ES]: {
    'chat.title': 'Chat',
    'chat.titleWithUnread': 'Chat, {count, plural, one {# mensaje no leído} other {# mensajes no leídos}}',
    'chat.unreadAnnouncement': '{count, plural, one {# mensaje no leído en el Chat} other {# mensajes no leídos en el Chat}}',
    'chat.expandNavigation': 'Expandir navegación',
    'chat.collapseNavigation': 'Contraer navegación',
    'chat.expandConversationList': 'Mostrar lista de conversaciones',
    'chat.collapseConversationList': 'Ocultar lista de conversaciones',
    'chat.conversationList': 'Lista de conversaciones',
    'chat.messageLog': 'Mensajes',
    'chat.loading': 'Preparando el Chat...',
    'chat.unavailableTitle': 'Chat no disponible',
    'chat.unavailableDescription': 'No pudimos cargar el Chat ahora. Inténtelo de nuevo.',
    'chat.retry': 'Intentar de nuevo',
    'chat.open': 'Abrir Chat',
    'chat.close': 'Cerrar',
    'chat.messages': 'Mensajes del Chat',
    'chat.openWithUnread': 'Abrir Chat, {count} mensajes no leídos'
  },
  [LOCALES.FR]: {
    'chat.title': 'Clavardage',
    'chat.titleWithUnread': 'Clavardage, {count} messages non lus',
    'chat.unreadAnnouncement': '{count} messages non lus dans le clavardage',
    'chat.expandNavigation': 'Développer la navigation',
    'chat.collapseNavigation': 'Réduire la navigation',
    'chat.expandConversationList': 'Afficher la liste des conversations',
    'chat.collapseConversationList': 'Masquer la liste des conversations',
    'chat.conversationList': 'Liste des conversations',
    'chat.messageLog': 'Messages',
    'chat.loading': 'Préparation du clavardage...',
    'chat.unavailableTitle': 'Clavardage indisponible',
    'chat.unavailableDescription': 'Impossible de charger le clavardage maintenant. Réessayez.',
    'chat.retry': 'Réessayer',
    'chat.open': 'Ouvrir le clavardage',
    'chat.close': 'Fermer',
    'chat.messages': 'Messages du clavardage',
    'chat.openWithUnread': 'Ouvrir le clavardage, {count} messages non lus'
  },
  [LOCALES.DE]: {
    'chat.title': 'Chat',
    'chat.titleWithUnread': 'Chat, {count} ungelesene Nachrichten',
    'chat.unreadAnnouncement': '{count} ungelesene Chat-Nachrichten',
    'chat.expandNavigation': 'Navigation erweitern',
    'chat.collapseNavigation': 'Navigation einklappen',
    'chat.expandConversationList': 'Konversationsliste anzeigen',
    'chat.collapseConversationList': 'Konversationsliste ausblenden',
    'chat.conversationList': 'Konversationsliste',
    'chat.messageLog': 'Nachrichten',
    'chat.loading': 'Chat wird vorbereitet...',
    'chat.unavailableTitle': 'Chat nicht verfügbar',
    'chat.unavailableDescription': 'Der Chat konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
    'chat.retry': 'Erneut versuchen',
    'chat.open': 'Chat öffnen',
    'chat.close': 'Schließen',
    'chat.messages': 'Chat-Nachrichten',
    'chat.openWithUnread': 'Chat öffnen, {count} ungelesene Nachrichten'
  },
  [LOCALES.RU]: {
    'chat.title': 'Чат',
    'chat.titleWithUnread': 'Чат, непрочитанных сообщений: {count}',
    'chat.unreadAnnouncement': 'Непрочитанных сообщений в чате: {count}',
    'chat.expandNavigation': 'Развернуть навигацию',
    'chat.collapseNavigation': 'Свернуть навигацию',
    'chat.expandConversationList': 'Показать список бесед',
    'chat.collapseConversationList': 'Скрыть список бесед',
    'chat.conversationList': 'Список бесед',
    'chat.messageLog': 'Сообщения',
    'chat.loading': 'Подготовка чата...',
    'chat.unavailableTitle': 'Чат недоступен',
    'chat.unavailableDescription': 'Не удалось загрузить чат. Повторите попытку.',
    'chat.retry': 'Повторить',
    'chat.open': 'Открыть чат',
    'chat.close': 'Закрыть',
    'chat.messages': 'Сообщения чата',
    'chat.openWithUnread': 'Открыть чат, непрочитанных сообщений: {count}'
  },
  [LOCALES.PL]: {
    'chat.title': 'Czat',
    'chat.titleWithUnread': 'Czat, nieprzeczytane wiadomości: {count}',
    'chat.unreadAnnouncement': 'Nieprzeczytane wiadomości na czacie: {count}',
    'chat.expandNavigation': 'Rozwiń nawigację',
    'chat.collapseNavigation': 'Zwiń nawigację',
    'chat.expandConversationList': 'Pokaż listę rozmów',
    'chat.collapseConversationList': 'Ukryj listę rozmów',
    'chat.conversationList': 'Lista rozmów',
    'chat.messageLog': 'Wiadomości',
    'chat.loading': 'Przygotowywanie czatu...',
    'chat.unavailableTitle': 'Czat niedostępny',
    'chat.unavailableDescription': 'Nie udało się teraz wczytać czatu. Spróbuj ponownie.',
    'chat.retry': 'Spróbuj ponownie',
    'chat.open': 'Otwórz czat',
    'chat.close': 'Zamknij',
    'chat.messages': 'Wiadomości czatu',
    'chat.openWithUnread': 'Otwórz czat, nieprzeczytane wiadomości: {count}'
  },
  [LOCALES.EL]: {
    'chat.title': 'Συνομιλία',
    'chat.titleWithUnread': 'Συνομιλία, {count} μη αναγνωσμένα μηνύματα',
    'chat.unreadAnnouncement': '{count} μη αναγνωσμένα μηνύματα συνομιλίας',
    'chat.expandNavigation': 'Ανάπτυξη πλοήγησης',
    'chat.collapseNavigation': 'Σύμπτυξη πλοήγησης',
    'chat.expandConversationList': 'Εμφάνιση λίστας συνομιλιών',
    'chat.collapseConversationList': 'Απόκρυψη λίστας συνομιλιών',
    'chat.conversationList': 'Λίστα συνομιλιών',
    'chat.messageLog': 'Μηνύματα',
    'chat.loading': 'Προετοιμασία συνομιλίας...',
    'chat.unavailableTitle': 'Η συνομιλία δεν είναι διαθέσιμη',
    'chat.unavailableDescription': 'Δεν ήταν δυνατή η φόρτωση της συνομιλίας. Δοκιμάστε ξανά.',
    'chat.retry': 'Δοκιμάστε ξανά',
    'chat.open': 'Άνοιγμα συνομιλίας',
    'chat.close': 'Κλείσιμο',
    'chat.messages': 'Μηνύματα συνομιλίας',
    'chat.openWithUnread': 'Άνοιγμα συνομιλίας, {count} μη αναγνωσμένα μηνύματα'
  },
  [LOCALES.ZH]: {
    'chat.title': '聊天',
    'chat.titleWithUnread': '聊天，{count} 条未读消息',
    'chat.unreadAnnouncement': '聊天中有 {count} 条未读消息',
    'chat.expandNavigation': '展开导航',
    'chat.collapseNavigation': '收起导航',
    'chat.expandConversationList': '显示会话列表',
    'chat.collapseConversationList': '隐藏会话列表',
    'chat.conversationList': '会话列表',
    'chat.messageLog': '消息',
    'chat.loading': '正在准备聊天...',
    'chat.unavailableTitle': '聊天不可用',
    'chat.unavailableDescription': '目前无法加载聊天，请重试。',
    'chat.retry': '重试',
    'chat.open': '打开聊天',
    'chat.close': '关闭',
    'chat.messages': '聊天消息',
    'chat.openWithUnread': '打开聊天，{count} 条未读消息'
  },
  [LOCALES.IT]: {
    'chat.title': 'Chat',
    'chat.titleWithUnread': 'Chat, {count} messaggi non letti',
    'chat.unreadAnnouncement': '{count} messaggi Chat non letti',
    'chat.expandNavigation': 'Espandi navigazione',
    'chat.collapseNavigation': 'Comprimi navigazione',
    'chat.expandConversationList': 'Mostra elenco conversazioni',
    'chat.collapseConversationList': 'Nascondi elenco conversazioni',
    'chat.conversationList': 'Elenco conversazioni',
    'chat.messageLog': 'Messaggi',
    'chat.loading': 'Preparazione della chat...',
    'chat.unavailableTitle': 'Chat non disponibile',
    'chat.unavailableDescription': 'Impossibile caricare la chat. Riprova.',
    'chat.retry': 'Riprova',
    'chat.open': 'Apri Chat',
    'chat.close': 'Chiudi',
    'chat.messages': 'Messaggi Chat',
    'chat.openWithUnread': 'Apri Chat, {count} messaggi non letti'
  },
  [LOCALES.HU]: {
    'chat.title': 'Csevegés',
    'chat.titleWithUnread': 'Csevegés, {count} olvasatlan üzenet',
    'chat.unreadAnnouncement': '{count} olvasatlan csevegési üzenet',
    'chat.expandNavigation': 'Navigáció kibontása',
    'chat.collapseNavigation': 'Navigáció összecsukása',
    'chat.expandConversationList': 'Beszélgetéslista megjelenítése',
    'chat.collapseConversationList': 'Beszélgetéslista elrejtése',
    'chat.conversationList': 'Beszélgetéslista',
    'chat.messageLog': 'Üzenetek',
    'chat.loading': 'Csevegés előkészítése...',
    'chat.unavailableTitle': 'A csevegés nem érhető el',
    'chat.unavailableDescription': 'A csevegés most nem tölthető be. Próbálja újra.',
    'chat.retry': 'Újra',
    'chat.open': 'Csevegés megnyitása',
    'chat.close': 'Bezárás',
    'chat.messages': 'Csevegési üzenetek',
    'chat.openWithUnread': 'Csevegés megnyitása, {count} olvasatlan üzenet'
  },
  [LOCALES.CS]: {
    'chat.title': 'Chat',
    'chat.titleWithUnread': 'Chat, {count} nepřečtených zpráv',
    'chat.unreadAnnouncement': '{count} nepřečtených zpráv v chatu',
    'chat.expandNavigation': 'Rozbalit navigaci',
    'chat.collapseNavigation': 'Sbalit navigaci',
    'chat.expandConversationList': 'Zobrazit seznam konverzací',
    'chat.collapseConversationList': 'Skrýt seznam konverzací',
    'chat.conversationList': 'Seznam konverzací',
    'chat.messageLog': 'Zprávy',
    'chat.loading': 'Příprava chatu...',
    'chat.unavailableTitle': 'Chat není dostupný',
    'chat.unavailableDescription': 'Chat se nyní nepodařilo načíst. Zkuste to znovu.',
    'chat.retry': 'Zkusit znovu',
    'chat.open': 'Otevřít chat',
    'chat.close': 'Zavřít',
    'chat.messages': 'Zprávy chatu',
    'chat.openWithUnread': 'Otevřít chat, {count} nepřečtených zpráv'
  },
  [LOCALES.DA]: {
    'chat.title': 'Chat',
    'chat.titleWithUnread': 'Chat, {count} ulæste beskeder',
    'chat.unreadAnnouncement': '{count} ulæste chatbeskeder',
    'chat.expandNavigation': 'Udvid navigation',
    'chat.collapseNavigation': 'Skjul navigation',
    'chat.expandConversationList': 'Vis samtaleliste',
    'chat.collapseConversationList': 'Skjul samtaleliste',
    'chat.conversationList': 'Samtaleliste',
    'chat.messageLog': 'Beskeder',
    'chat.loading': 'Forbereder chat...',
    'chat.unavailableTitle': 'Chat er ikke tilgængelig',
    'chat.unavailableDescription': 'Chatten kunne ikke indlæses nu. Prøv igen.',
    'chat.retry': 'Prøv igen',
    'chat.open': 'Åbn chat',
    'chat.close': 'Luk',
    'chat.messages': 'Chatbeskeder',
    'chat.openWithUnread': 'Åbn chat, {count} ulæste beskeder'
  },
  [LOCALES.FI]: {
    'chat.title': 'Chat',
    'chat.titleWithUnread': 'Chat, {count} lukematonta viestiä',
    'chat.unreadAnnouncement': '{count} lukematonta chat-viestiä',
    'chat.expandNavigation': 'Laajenna navigointi',
    'chat.collapseNavigation': 'Pienennä navigointi',
    'chat.expandConversationList': 'Näytä keskusteluluettelo',
    'chat.collapseConversationList': 'Piilota keskusteluluettelo',
    'chat.conversationList': 'Keskusteluluettelo',
    'chat.messageLog': 'Viestit',
    'chat.loading': 'Valmistellaan chattia...',
    'chat.unavailableTitle': 'Chat ei ole käytettävissä',
    'chat.unavailableDescription': 'Chatia ei voitu ladata. Yritä uudelleen.',
    'chat.retry': 'Yritä uudelleen',
    'chat.open': 'Avaa chat',
    'chat.close': 'Sulje',
    'chat.messages': 'Chat-viestit',
    'chat.openWithUnread': 'Avaa chat, {count} lukematonta viestiä'
  },
  [LOCALES.NO]: {
    'chat.title': 'Chat',
    'chat.titleWithUnread': 'Chat, {count} uleste meldinger',
    'chat.unreadAnnouncement': '{count} uleste chatmeldinger',
    'chat.expandNavigation': 'Utvid navigasjon',
    'chat.collapseNavigation': 'Skjul navigasjon',
    'chat.expandConversationList': 'Vis samtaleliste',
    'chat.collapseConversationList': 'Skjul samtaleliste',
    'chat.conversationList': 'Samtaleliste',
    'chat.messageLog': 'Meldinger',
    'chat.loading': 'Forbereder chat...',
    'chat.unavailableTitle': 'Chat er utilgjengelig',
    'chat.unavailableDescription': 'Chatten kunne ikke lastes inn nå. Prøv igjen.',
    'chat.retry': 'Prøv igjen',
    'chat.open': 'Åpne chat',
    'chat.close': 'Lukk',
    'chat.messages': 'Chatmeldinger',
    'chat.openWithUnread': 'Åpne chat, {count} uleste meldinger'
  },
  [LOCALES.SV]: {
    'chat.title': 'Chatt',
    'chat.titleWithUnread': 'Chatt, {count} olästa meddelanden',
    'chat.unreadAnnouncement': '{count} olästa chattmeddelanden',
    'chat.expandNavigation': 'Expandera navigering',
    'chat.collapseNavigation': 'Fäll ihop navigering',
    'chat.expandConversationList': 'Visa konversationslista',
    'chat.collapseConversationList': 'Dölj konversationslista',
    'chat.conversationList': 'Konversationslista',
    'chat.messageLog': 'Meddelanden',
    'chat.loading': 'Förbereder chatten...',
    'chat.unavailableTitle': 'Chatten är inte tillgänglig',
    'chat.unavailableDescription': 'Chatten kunde inte läsas in nu. Försök igen.',
    'chat.retry': 'Försök igen',
    'chat.open': 'Öppna chatt',
    'chat.close': 'Stäng',
    'chat.messages': 'Chattmeddelanden',
    'chat.openWithUnread': 'Öppna chatt, {count} olästa meddelanden'
  }
};

const panelMessages = {
  [LOCALES.PT]: {
    'chat.pageTitle': 'Central de Conversas',
    'chat.pageSubtitle': 'Atenda, acompanhe e gerencie suas conversas em um só lugar.',
    'chat.panelTitle': 'Central de Conversas',
    'chat.openAsPanel': 'Modo painel',
    'chat.openFullPage': 'Abrir em página completa',
    'chat.minimize': 'Minimizar',
    'chat.pinPanel': 'Fixar painel',
    'chat.unpinPanel': 'Desfixar painel',
    'chat.pinPanelUnavailable': 'Fixação indisponível nesta largura de tela',
    'chat.restore': 'Restaurar Chat',
    'chat.restoreWithUnread': 'Restaurar Chat, {count, plural, one {# mensagem não lida} other {# mensagens não lidas}}',
    'chat.panelLabel': 'Painel do Chat',
    'chat.panelMinimizedForWidth': 'O painel do Chat foi minimizado por falta de espaço.'
  },
  [LOCALES.EN]: {
    'chat.pageTitle': 'Conversation Center',
    'chat.pageSubtitle': 'Support, follow up and manage your conversations in one place.',
    'chat.panelTitle': 'Conversation Center',
    'chat.openAsPanel': 'Panel mode',
    'chat.openFullPage': 'Open full page',
    'chat.minimize': 'Minimize',
    'chat.pinPanel': 'Pin panel',
    'chat.unpinPanel': 'Unpin panel',
    'chat.pinPanelUnavailable': 'Pinning is unavailable at this screen width',
    'chat.restore': 'Restore Chat',
    'chat.restoreWithUnread': 'Restore Chat, {count, plural, one {# unread message} other {# unread messages}}',
    'chat.panelLabel': 'Chat panel',
    'chat.panelMinimizedForWidth': 'The Chat panel was minimized because there is not enough space.'
  },
  [LOCALES.ES]: {
    'chat.pageTitle': 'Central de Conversaciones',
    'chat.pageSubtitle': 'Atienda, acompañe y gestione sus conversaciones en un solo lugar.',
    'chat.panelTitle': 'Central de Conversaciones',
    'chat.openAsPanel': 'Modo panel',
    'chat.openFullPage': 'Abrir en página completa',
    'chat.minimize': 'Minimizar',
    'chat.pinPanel': 'Fijar panel',
    'chat.unpinPanel': 'Desfijar panel',
    'chat.pinPanelUnavailable': 'La fijación no está disponible con este ancho de pantalla',
    'chat.restore': 'Restaurar Chat',
    'chat.restoreWithUnread': 'Restaurar Chat, {count, plural, one {# mensaje no leído} other {# mensajes no leídos}}',
    'chat.panelLabel': 'Panel del Chat',
    'chat.panelMinimizedForWidth': 'El panel del Chat se minimizó porque no hay espacio suficiente.'
  }
};

const mobileConversationMessages = {
  [LOCALES.PT]: {
    'chat.returnToConversation': 'Voltar para a conversa'
  },
  [LOCALES.EN]: {
    'chat.returnToConversation': 'Return to conversation'
  },
  [LOCALES.ES]: {
    'chat.returnToConversation': 'Volver a la conversación'
  }
};

const panelTitleMessages = {
  [LOCALES.PT]: 'Central de Conversas',
  [LOCALES.EN]: 'Conversation Center',
  [LOCALES.ES]: 'Central de Conversaciones',
  [LOCALES.FR]: 'Centre de conversations',
  [LOCALES.DE]: 'Konversationszentrale',
  [LOCALES.RU]: 'Центр бесед',
  [LOCALES.PL]: 'Centrum rozmów',
  [LOCALES.EL]: 'Κέντρο συνομιλιών',
  [LOCALES.ZH]: '会话中心',
  [LOCALES.IT]: 'Centro conversazioni',
  [LOCALES.HU]: 'Beszélgetési központ',
  [LOCALES.CS]: 'Centrum konverzací',
  [LOCALES.DA]: 'Samtalecenter',
  [LOCALES.FI]: 'Keskustelukeskus',
  [LOCALES.NO]: 'Samtalesenter',
  [LOCALES.SV]: 'Konversationscenter'
};

const identityConflictMessages = {
  [LOCALES.PT]: {
    'chat.identityConflictTitle': 'Identificamos uma identidade de atendimento existente',
    'chat.identityConflictDescription': 'Este e-mail já está associado a uma identidade autenticada no atendimento. Você pode usar essa identidade para manter seu histórico e as personalizações.',
    'chat.useExistingIdentity': 'Usar minha identidade existente',
    'chat.continueAnonymously': 'Seguir sem autenticação',
    'chat.anonymousWarning': 'Ao seguir sem autenticação, seu acesso ao histórico de chat e às personalizações do atendimento ficará limitado. Talvez seja necessário informar seu e-mail novamente.'
  },
  [LOCALES.EN]: {
    'chat.identityConflictTitle': 'We found an existing support identity',
    'chat.identityConflictDescription': 'This email is already linked to an authenticated support identity. You can use it to keep your history and personalization.',
    'chat.useExistingIdentity': 'Use my existing identity',
    'chat.continueAnonymously': 'Continue without support authentication',
    'chat.anonymousWarning': 'Previous conversations, cross-device history, and personalization may be unavailable. You may need to provide your email again.'
  },
  [LOCALES.ES]: {
    'chat.identityConflictTitle': 'Encontramos una identidad de atención existente',
    'chat.identityConflictDescription': 'Este correo ya está vinculado a una identidad autenticada de atención. Puede usarla para mantener su historial y personalización.',
    'chat.useExistingIdentity': 'Usar mi identidad existente',
    'chat.continueAnonymously': 'Continuar sin autenticación de atención',
    'chat.anonymousWarning': 'Las conversaciones anteriores, el historial entre dispositivos y la personalización podrían no estar disponibles. Tal vez deba informar su correo nuevamente.'
  },
  [LOCALES.FR]: {
    'chat.identityConflictTitle': "Nous avons trouvé une identité d'assistance existante",
    'chat.identityConflictDescription': "Cette adresse e-mail est déjà associée à une identité d'assistance authentifiée. Vous pouvez l'utiliser pour conserver votre historique et vos personnalisations.",
    'chat.useExistingIdentity': 'Utiliser mon identité existante',
    'chat.continueAnonymously': "Continuer sans authentification de l'assistance",
    'chat.anonymousWarning': "Les conversations précédentes, l'historique sur plusieurs appareils et les personnalisations peuvent être indisponibles. Vous devrez peut-être saisir à nouveau votre adresse e-mail."
  },
  [LOCALES.DE]: {
    'chat.identityConflictTitle': 'Wir haben eine bestehende Support-Identität gefunden',
    'chat.identityConflictDescription': 'Diese E-Mail-Adresse ist bereits mit einer authentifizierten Support-Identität verknüpft. Sie können sie verwenden, um Verlauf und Personalisierung beizubehalten.',
    'chat.useExistingIdentity': 'Bestehende Identität verwenden',
    'chat.continueAnonymously': 'Ohne Support-Authentifizierung fortfahren',
    'chat.anonymousWarning': 'Frühere Unterhaltungen, der geräteübergreifende Verlauf und Personalisierungen sind möglicherweise nicht verfügbar. Eventuell müssen Sie Ihre E-Mail-Adresse erneut angeben.'
  },
  [LOCALES.RU]: {
    'chat.identityConflictTitle': 'Найдена существующая учетная запись поддержки',
    'chat.identityConflictDescription': 'Этот адрес уже связан с подтвержденной учетной записью поддержки. Используйте ее, чтобы сохранить историю и персонализацию.',
    'chat.useExistingIdentity': 'Использовать существующую учетную запись',
    'chat.continueAnonymously': 'Продолжить без авторизации в поддержке',
    'chat.anonymousWarning': 'Предыдущие беседы, история на других устройствах и персонализация могут быть недоступны. Возможно, потребуется снова указать электронную почту.'
  },
  [LOCALES.PL]: {
    'chat.identityConflictTitle': 'Znaleźliśmy istniejącą tożsamość pomocy technicznej',
    'chat.identityConflictDescription': 'Ten adres e-mail jest już powiązany z uwierzytelnioną tożsamością pomocy. Możesz jej użyć, aby zachować historię i personalizację.',
    'chat.useExistingIdentity': 'Użyj istniejącej tożsamości',
    'chat.continueAnonymously': 'Kontynuuj bez uwierzytelnienia pomocy',
    'chat.anonymousWarning': 'Poprzednie rozmowy, historia na różnych urządzeniach i personalizacja mogą być niedostępne. Może być konieczne ponowne podanie adresu e-mail.'
  },
  [LOCALES.EL]: {
    'chat.identityConflictTitle': 'Βρήκαμε υπάρχουσα ταυτότητα υποστήριξης',
    'chat.identityConflictDescription': 'Αυτό το email συνδέεται ήδη με επαληθευμένη ταυτότητα υποστήριξης. Μπορείτε να τη χρησιμοποιήσετε για να διατηρήσετε το ιστορικό και την εξατομίκευση.',
    'chat.useExistingIdentity': 'Χρήση υπάρχουσας ταυτότητας',
    'chat.continueAnonymously': 'Συνέχεια χωρίς έλεγχο ταυτότητας υποστήριξης',
    'chat.anonymousWarning': 'Οι προηγούμενες συνομιλίες, το ιστορικό μεταξύ συσκευών και η εξατομίκευση ενδέχεται να μην είναι διαθέσιμα. Ίσως χρειαστεί να δώσετε ξανά το email σας.'
  },
  [LOCALES.ZH]: {
    'chat.identityConflictTitle': '发现已有的客服身份',
    'chat.identityConflictDescription': '此电子邮件已关联到经过身份验证的客服身份。您可以使用该身份保留历史记录和个性化设置。',
    'chat.useExistingIdentity': '使用我已有的身份',
    'chat.continueAnonymously': '不进行客服身份验证并继续',
    'chat.anonymousWarning': '之前的对话、跨设备历史记录和个性化设置可能不可用。您可能需要再次提供电子邮件。'
  },
  [LOCALES.IT]: {
    'chat.identityConflictTitle': 'Abbiamo trovato una identità di assistenza esistente',
    'chat.identityConflictDescription': 'Questa email è già collegata a una identità di assistenza autenticata. Puoi usarla per conservare cronologia e personalizzazione.',
    'chat.useExistingIdentity': 'Usa la mia identità esistente',
    'chat.continueAnonymously': 'Continua senza autenticazione di assistenza',
    'chat.anonymousWarning': 'Le conversazioni precedenti, la cronologia tra dispositivi e la personalizzazione potrebbero non essere disponibili. Potrebbe essere necessario fornire nuovamente la tua email.'
  },
  [LOCALES.HU]: {
    'chat.identityConflictTitle': 'Meglévő ügyfélszolgálati azonosítót találtunk',
    'chat.identityConflictDescription': 'Ez az e-mail-cím már hitelesített ügyfélszolgálati azonosítóhoz kapcsolódik. Használatával megőrizheti az előzményeket és a személyre szabást.',
    'chat.useExistingIdentity': 'Meglévő azonosító használata',
    'chat.continueAnonymously': 'Folytatás ügyfélszolgálati hitelesítés nélkül',
    'chat.anonymousWarning': 'A korábbi beszélgetések, az eszközök közötti előzmények és a személyre szabás nem feltétlenül lesznek elérhetők. Előfordulhat, hogy újra meg kell adnia az e-mail-címét.'
  },
  [LOCALES.CS]: {
    'chat.identityConflictTitle': 'Našli jsme existující identitu podpory',
    'chat.identityConflictDescription': 'Tento e-mail je již propojen s ověřenou identitou podpory. Jejím použitím zachováte historii a přizpůsobení.',
    'chat.useExistingIdentity': 'Použít existující identitu',
    'chat.continueAnonymously': 'Pokračovat bez ověření podpory',
    'chat.anonymousWarning': 'Předchozí konverzace, historie mezi zařízeními a přizpůsobení nemusí být dostupné. Možná budete muset e-mail zadat znovu.'
  },
  [LOCALES.DA]: {
    'chat.identityConflictTitle': 'Vi fandt en eksisterende supportidentitet',
    'chat.identityConflictDescription': 'Denne e-mail er allerede knyttet til en godkendt supportidentitet. Du kan bruge den til at bevare historik og tilpasning.',
    'chat.useExistingIdentity': 'Brug min eksisterende identitet',
    'chat.continueAnonymously': 'Fortsæt uden supportgodkendelse',
    'chat.anonymousWarning': 'Tidligere samtaler, historik på tværs af enheder og tilpasning er muligvis ikke tilgængelige. Du skal muligvis angive din e-mail igen.'
  },
  [LOCALES.FI]: {
    'chat.identityConflictTitle': 'Löysimme olemassa olevan tukipalvelun käyttäjätunnuksen',
    'chat.identityConflictDescription': 'Tämä sähköposti on jo liitetty todennettuun tukipalvelun käyttäjätunnukseen. Voit säilyttää historian ja mukautukset käyttämällä sitä.',
    'chat.useExistingIdentity': 'Käytä olemassa olevaa tunnustani',
    'chat.continueAnonymously': 'Jatka ilman tukipalvelun tunnistautumista',
    'chat.anonymousWarning': 'Aiemmat keskustelut, laitteiden välinen historia ja mukautukset eivät ehkä ole käytettävissä. Sähköposti on ehkä annettava uudelleen.'
  },
  [LOCALES.NO]: {
    'chat.identityConflictTitle': 'Vi fant en eksisterende supportidentitet',
    'chat.identityConflictDescription': 'Denne e-postadressen er allerede knyttet til en autentisert supportidentitet. Du kan bruke den for å beholde historikk og tilpasning.',
    'chat.useExistingIdentity': 'Bruk min eksisterende identitet',
    'chat.continueAnonymously': 'Fortsett uten supportautentisering',
    'chat.anonymousWarning': 'Tidligere samtaler, historikk på tvers av enheter og tilpasning er kanskje ikke tilgjengelig. Du må kanskje oppgi e-postadressen på nytt.'
  },
  [LOCALES.SV]: {
    'chat.identityConflictTitle': 'Vi hittade en befintlig supportidentitet',
    'chat.identityConflictDescription': 'Den här e-postadressen är redan kopplad till en autentiserad supportidentitet. Du kan använda den för att behålla historik och anpassningar.',
    'chat.useExistingIdentity': 'Använd min befintliga identitet',
    'chat.continueAnonymously': 'Fortsätt utan supportautentisering',
    'chat.anonymousWarning': 'Tidigare konversationer, historik mellan enheter och anpassningar kanske inte är tillgängliga. Du kan behöva ange din e-postadress igen.'
  }
};

Object.entries(chat).forEach(([locale, messages]) => {
  Object.assign(
    messages,
    panelMessages[locale] || panelMessages[LOCALES.EN],
    mobileConversationMessages[locale] || mobileConversationMessages[LOCALES.EN],
    identityConflictMessages[locale] || identityConflictMessages[LOCALES.EN],
    {
      'chat.panelTitle': panelTitleMessages[locale] || panelTitleMessages[LOCALES.EN]
    }
  );
});

export default chat;

